const CHANNEL_NAME = 'smart-plat';

/**
 * BroadcastChannelのラッパーロジック
 */
export const useBroadcastCannel = <T>() => {
  const broadcastChannel = useState('broadcast-channel', () => new BroadcastChannel(CHANNEL_NAME));

  /**
   * 他タブから通知を受け取った際の処理を登録する
   *
   * @param onmessage 通知を受け取った際の処理
   */
  const registerOnmessage = (onmessage: (_message: T) => void) => {
    broadcastChannel.value.onmessage = (event) => onmessage(event.data as T);
  };

  /**
   * 他タブに通知する
   *
   * @param message 通知メッセージ
   */
  const postMessage = (message: T) => broadcastChannel.value.postMessage(message);

  return {
    registerOnmessage,
    postMessage,
  };
};
